const noop = () => {
  console.log(
    'The no-op default function has been called. A function provided to a component may be missing.',
  );
};

export default noop;
